export default function parseCustomDateString(dateString: string): Date {

  const [year, month, day] = dateString.split('-');

  if (!year || !month || !day) {

    throw new Error('invalid date provided in calculateRemainingTime');
  
  } else {

    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  
  }

}
